import createBrowserHistory from 'history/createBrowserHistory'

const history = createBrowserHistory({ basename: process.env.REACT_APP_ROUTER_BASE_PATH })

export default history



// WEBPACK FOOTER //
// ./src/Auth/history.js